import React from 'react';
import { Helmet } from 'react-helmet-async';
import seoConfig from '../config/seoConfig';

const BaiduAnalytics = ({ baiduId = seoConfig.baidu.analyticsId }) => {
  // 百度统计代码
  const baiduScript = `
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?${baiduId}";
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
    })();
  `;

  return (
    <Helmet>
      {/* 百度统计代码 */}
      <script>{baiduScript}</script>
      
      {/* 百度站长验证 */}
      <meta name="baidu-site-verification" content={seoConfig.baidu.siteVerification} />
      
      {/* 百度智能小程序关联 */}
      <meta name="applicable-device" content="pc,mobile" />
      
      {/* 百度搜索资源平台相关 */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="format-detection" content="email=no" />
      <meta name="format-detection" content="address=no" />
    </Helmet>
  );
};

export default BaiduAnalytics;